<template>
    <div class="stamp-exchange-detail">

        <!-- 图片轮播区域 -->
        <div class="page-section page-section-spacing swiper">
            <swiper
                class="swiperBox"
                :indicator-dots="indicatorDots"
                @change="swiperChange"
                :autoplay="autoplay"
                :interval="interval"
                :duration="duration"
                :circular="circular"
            >
                <swiper-item
                    v-for="(item, index) in commodityPicPos"
                    :key="index"
                    class="swiperItem"
                >
                    <img
                        class="swiperImg"
                        style="width: 100%; height: 100%;"
                        :src="imgUrl + item"
                        mode="aspectFit"
                    />
                </swiper-item>
            </swiper>
            <div class="indexShow" v-if="commodityPicPos.length > 0">
                {{ swiperIndex }} / {{ commodityPicPos.length }}
            </div>
        </div>

        <!-- 商品信息 -->
        <div class="good-info">
            <div class="stamps"><span style="font-size: 24px;">{{ stamps }}</span> 印花</div>
            <div class="title">{{ name }}</div>
        </div>

        <!-- 商品简介 -->
        <div class="good-info">
            <div>
                <img class="desc-icon" src="@/assets/change-desc-icon.svg" />
                <span class="title">商品简介</span>
            </div>
            <div class="desc">{{ content }}</div>
        </div>

        <!-- 商品详情图片 -->
        <div style="margin: 10px;background: #ffffff;">
            <div
                v-for="(item, index) in commodityDetailPos"
                :key="index"
                style="text-align: center;"
            >
                <img
                    class="detail-images"
                    mode="widthFix"
                    :src="imgUrl + item"
                />
            </div>
        </div>

        <!-- 兑换按钮 -->
        <div class="exchange-bg">
            <button
                v-if="userStamps >= stamps"
                class="exchange-btn"
                @click="exchangeBtn"
            >
                兑换
            </button>
            <button
                v-else
                class="exchange-btn off"
            >
                兑换
            </button>
        </div>
        <!-- Toast 提示 -->
        <Toast ref="toast"></Toast>
    </div>
</template>

<script>
import { GetExchangeGoods } from '../../api/StampShop'
import {BASE_URL} from "@/config/app";

export default {
    name: 'StampExchangeDetail',
    data() {
        return {
            id: '',
            userStamps: 0,
            name: '',
            stamps: 0,
            commodityPicPos: [],
            commodityDetailPos: [],
            content: '',
            autoplay: true,
            indicatorDots: false,
            interval: 4000,
            duration: 500,
            circular: true,
            swiperIndex: 1,
            imgUrl: BASE_URL || '',
            isChange: false,
        }
    },
    created() {
        this.id = this.$route.query.id
        this.userStamps = Number(this.$route.query.userStamps) || 0
        this.loadDetail()
    },
    methods: {
        // Toast 提示方法
        toast(e) {
            this.$refs.toast.show(e, 1500);
        },
        // 返回上一页
        back() {
            this.$router.go(-1)
        },

        // 加载商品详情
        async loadDetail() {
            try {
                const res = await GetExchangeGoods({ duiId: this.id, activityId: 1 })

                if (res.code === this.$API_CODE.OK) {
                    this.name = res.data.productname
                    this.content = res.data.content
                    this.stamps = res.data.stampQuantity
                    this.commodityPicPos = res.data.imgurlList
                    this.commodityDetailPos = res.data.imgurlDetailList
                } else {
                    this.toast(res.message || '获取商品详情失败')
                }
            } catch (error) {
                console.error('获取商品详情失败:', error)
                this.toast('获取商品详情失败')
            }
        },

        // 轮播图切换事件
        swiperChange(e) {
            this.swiperIndex = e.detail.current + 1
        },

        // 兑换按钮点击事件
        exchangeBtn() {
            this.$router.push({
                path: '/stampExchangeConfirm',
                query: {
                    id: this.id,
                    userStamps: this.userStamps
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.stamp-exchange-detail {
    background-color: #f8f8f8;
    min-height: 100vh;
    padding-bottom: 70px;
}

/* 顶部标题栏 */
.header {
    height: 45px;
    line-height: 45px;
    background-color: #ed3f14;
    padding: 0 10px;
    position: relative;
}

.back {
    width: 16px;
    height: 16px;
    float: left;
    margin-top: 15px;
    margin-right: 10px;
    cursor: pointer;
}

.title {
    margin-top: 5px;
    font-size: 16px;
    font-weight: bold;
}

/* 轮播图区域 */
.page-section {
    position: relative;
    height: 375px;
}

.swiperBox {
    height: 375px;
    position: relative;
}

.indexShow {
    position: absolute;
    right: 20px;
    bottom: 20px;
    background: rgba(247, 247, 247, 0.8);
    color: #aaa4a4;
    font-size: 14px;
    padding: 5px 15px;
    border-radius: 15px;
    z-index: 10;
}

/* 商品信息 */
.good-info {
    margin: 10px;
    border-radius: 5px;
    padding: 15px;
    font-size: 14px;
    color: #333333;
    background: #FFFFFF;
    text-align: left;

    .stamps {
        color: #D33A35;
    }

    .title {
        margin-top: 5px;
        font-size: 16px;
        font-weight: bold;
    }

    .desc {
        margin-top: 5px;
    }

    .desc-icon {
        width: 20px;
        height: 20px;
        margin-right: 10px;
        vertical-align: middle;
    }
}


/* 兑换按钮区域 */
.exchange-bg {
    width: 90%;
    position: fixed;
    left: 5%;
    right: 5%;
    bottom: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    color: #D33A35;

    .exchange-btn {
        background: #D33A35;
        border-radius: 25px;
        width: 100%;
        height: 50px;
        line-height: 50px;
        padding: 0;
        color: #ffffff;
        font-size: 20px;
        border: none;
        cursor: pointer;

        &:active {
            opacity: 0.8;
        }
    }

    .off {
        background: #999999;
        cursor: not-allowed;
    }
}

/* 详情图片 */
.detail-images {
    width: 100%;
    align-items: center;
}
</style>
